module.exports = __webpack_public_path__ + "img/5.fde58af6.png";